import api from './api';
import { ServiceType } from '../types/barber.types';

export const serviceTypeService = {
    getAllServices: async (): Promise<ServiceType[]> => {
        const response = await api.get<ServiceType[]>('/services');
        return response.data;
    },
    createService: async (service: Omit<ServiceType, 'id'>): Promise<ServiceType> => {
        const response = await api.post<ServiceType>('/services', service);
        return response.data;
    },
    updateService: async (id: number, service: Omit<ServiceType, 'id'>): Promise<ServiceType> => {
        const response = await api.put<ServiceType>(`/services/${id}`, service);
        return response.data;
    },
    deleteService: async (id: number): Promise<void> => {
        await api.delete(`/services/${id}`);
    }
};
